import React, { useContext, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Context } from '../../ContextApi/ContextApi'
import LogOut from '../../Pages/LogOut';
import { useNavigate } from 'react-router-dom'
import style from './index.module.css'
export default function () {
  const {user,setUser} = useContext(Context) 
  const navigate = useNavigate();
  const [isAccountVisible, setIsAccountVisible] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userInfo');
    
    setUser(null); 
    
    navigate('/');
  };
  const toggleAccountVisibility = () => {
    setIsAccountVisible(!isAccountVisible);
  };
  return (
    <div className='nvb'>
      <nav>
        <div className={style.div1}>
            <div className={style.icons} >
               <NavLink  onClick={toggleAccountVisibility}><i className="fa-regular fa-user"></i></NavLink> 
                <NavLink to="/basket"><i className="fa-solid fa-basket-shopping"></i></NavLink>
                <NavLink to="/wishlist"><i className="fa-regular fa-heart"></i></NavLink>
                <NavLink><i className="fa-solid fa-magnifying-glass"></i></NavLink>
            </div>
            {isAccountVisible && (
            <div className={style.account}>
              <NavLink className='text-dark' to='/myaccount'> My Accounts</NavLink><br></br><hr></hr>
              <NavLink className='text-dark'>Language</NavLink><br></br><hr></hr>
              <NavLink className={style.login} to="/login">Login</NavLink><br></br><hr></hr>
              <p>No account yet? <NavLink to="/registr">Register Here</NavLink></p>
            </div>
          )}
            <div className={style.nav}>
              <ul className={style.navbarul} type='none'>
                <li><NavLink to="/contact"  className='text-dark'>Contact</NavLink></li>
                <li><NavLink to="/about" className='text-dark'>About</NavLink></li>
                <li><NavLink to="/shop" className='text-dark'>Shop</NavLink></li>
                <li><NavLink to="/" className='text-dark'>Home</NavLink></li>
                <li><NavLink to="/category" className='text-dark'>Category</NavLink></li>
              </ul>
            </div>
            <div className={style.logo}><a><img src='logo (2).png'></img></a> </div>
        </div>
      </nav>
      {/*
      <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
        <div className="container-fluid">
          <ul className="navbar-nav">
            { user?.role === 'user' &&(
              <li className="nav-item">
                <NavLink to="/" className='nav-link'>Home</NavLink>
              </li>
            )}
            {user?.role === 'admin' &&(
              <li className="nav-item">
                <NavLink to="/about" className='nav-link'>About</NavLink>
              </li>

            )}
            <li className="nav-item">
              <NavLink to="/details" className='nav-link'>Details</NavLink>
            </li>
            { user?.loggedIn && (
                <li className='nav-item'>
                  <button onClick={handleLogout} >LogOut</button>
                </li>
              )}
              {!user?.loggedIn &&(
                <li className='nav-item'>
                  <NavLink to="/login" className='nav-link'>Login</NavLink>
                </li>

              )}
            {!user?.loggedIn &&(
              <li className='nav-item'>
                  <NavLink to="/registr" className="nav-link">Registr</NavLink>
                </li>
              )}
          </ul>
        </div>
      </nav> */}
    </div>
  )
}